import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ButtonLineComponent, FieldComponent, GroupComponent } from '@bas/ui';
import { Button } from '@openng/optimus-ui/button';
import { DialogService } from '@openng/optimus-ui/dynamicdialog';
import { ButtonModule } from '../shared/elements/button/button.module';
import { MsgKeyModule } from '../shared/translate/msg-key.module';
import { AdblockDialogComponent } from './adblock-dialog.component';
import { AdblockService } from './adblock.service';

@NgModule({
	imports: [
		ButtonModule,
		MsgKeyModule,
		ButtonModule,
		GroupComponent,
		FieldComponent,
		ButtonLineComponent,
		Button,
	],
	declarations: [
		AdblockDialogComponent,
	],
	providers: [
		AdblockService,
		DialogService,
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AdblockModule {}
